export default [
  {
    name: 'ReportsList',
    path: '/reports',
    component: () => import('src/pages/reports/ReportsList.vue')
  },
  {
    name: 'ReportsCustomersList',
    path: '/reports/customers',
    component: () => import('src/pages/reports/ReportsCustomersList.vue')
  },
  {
    name: 'ReportsProductivityList',
    path: '/reports/productivity',
    component: () => import('src/pages/reports/ReportsProductivityList.vue')
  },
  {
    name: 'ReportsCreditProcessesList',
    path: '/reports/credit-processes',
    component: () => import('src/pages/reports/ReportsCreditProcessesList.vue')
  }
]
